import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

import GutterDecorator from "../../gutter-decorator.tsx";

export default function ParagraphNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, element, children} = props;

    return (
        <Body {...attributes} tag="p" style={styles.body}>
            <GutterDecorator element={element}>{children}</GutterDecorator>
        </Body>
    );
}

const styles = StyleSheet.create({
    body: {
        marginBlockEnd: spacing.medium_16,
        paddingBlockStart: 0,
        marginBlockStart: 0,
    },
});
